import {makeStyles} from "tss-react/mui";
import {Box, Stack, Switch, SwitchProps, Typography} from "@mui/material";
import {AdminFieldContainer, IProps as AdminFieldContainerProps} from "@/pages/ManagerView/ContentCreation/AdminFieldContainer";

const useStyles = makeStyles()((theme) => ({
	adminInputSwitch: {},
	textField: {
		width: "100%"
	}
}));

export type IProps = Omit<AdminFieldContainerProps, "children"> & Omit<SwitchProps, "className" | "error"> & {
	className?: string;
	label: string;
	error?: string;
	/** Default: label to the right of the switch */
	labelPlacement?: "inline" | "above";
};

export const AdminInputSwitch = ({
	label,
	outline,
	className,
	error,
	required,
	labelPlacement = "inline",
	...switchProps
}: IProps): JSX.Element => {
	const {cx, classes} = useStyles();
	return (
		<Box className={cx(classes.adminInputSwitch, className)}>
			<AdminFieldContainer error={error} required={required} outline={outline}>
				{labelPlacement === "above" ? (
					<Stack spacing={1}>
						<Typography
							component="label"
							sx={(theme) => ({
								fontWeight: 600,
								"& .req": {color: theme.palette.error.main}
							})}
						>
							{label}
							{required ? <span className="req"> *</span> : null}
						</Typography>
						<Switch {...switchProps} />
					</Stack>
				) : (
					<Stack direction="row" spacing={1} sx={{alignItems: "center"}}>
						<Switch {...switchProps} />
						<Typography>{label}</Typography>
					</Stack>
				)}
			</AdminFieldContainer>
		</Box>
	);
};